// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
export const setRovoChatProduct = (product: string): void => {
	if (window) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(window as any).__ROVO_CHAT_CONFIG_PRODUCT__ = product;
	}
};
